export default {
    nodata: "No Content",
    contact: "Contact Us",
    load_txt: "Loading...",
    // 底部导航  
    offiaccount: "UPS APA Official Account",
    miniprogram: "UPS APA Mini Program",
    miniprogram_scan: "Scan QR Code to View Mini Program",
    miniprogram_car: "APA Car Owner Mini Program",
    foot_1: "Select Lights | In-store Installation | Latest News | Order Services",
    foot_2: "Warranty Check",
    foot_3: "Anyishi Factory",
    foot_4: "APA Brand",
    foot_5: "Store Locator",
    foot_6: "Investment & Franchise",
    wx_name: "Official WeChat",
    dy_name: "Official Douyin",
    wb_name: "Official Weibo",
    // 组件  
    btn_detail: "Learn More",
    top_txt_seat: "Current Location",

    pay_txt: "Buy Now",
    manual_txt: "Download Technical Manual",
    goods_detail_1: "Product Details",
    goods_detail_2: "Name",
    goods_detail_3: "Specifications",

    store_input: "Please Enter Store Name",
    store_locate: "Unable to get your location, please check your network and location services.",
    store_locate_btn: "Relocate",
    store_phone: "Phone",
    store_time: "Time",

    //按钮
    "btn_search": "Search",
    "btn_cancel": "Cancel",

    //信息

    "phone": "Phone Number",
    "barcode": "Barcode",
    "input_select": "Please Select",

    //质保查询

    "warranty_no": "No product found for this barcode",
    "warranty_input": "Please enter product serial number or installation phone number",
    "warranty_input2": "Please enter license plate number",
    "warranty_title": "Warranty Inquiry",

    "warranty_name": "Product",
    "warranty_price": "Retail Price",
    "warranty_barcode": "Product Code",
    "warranty_querytime": "First Inquiry",
    "warranty_carmodel": "Installed Vehicle Model",
    "warranty_storename": "Installation Store",
    "installtime": "Installation Time",
    "storesphone": "Store Phone",
    "storeaddress": "Store Address",

    "warranty_scan1": "Scan to View Details",
    "warranty_scan2": "Scan to View My Warranty",
    "warranty_result": "Inquiry Result",

    "warranty_status1": "Status",
    "warranty_status2": "Warranty",
    "warranty_status_result1": "Not Installed",
    "warranty_status_result2": "Installed",
    "warranty_status_result3": "Expired"

}